<template>
  <div>
    <section-title
      :header-id="sectionData.node_name"
      :title="sectionData.fields.title"
      :browse-title="sectionData.fields.button_all || ''"
      :browse-link="{ name: 'Press', params: { biennale } }"
      class="mb-5 mb-md-10"
    />
    <horizontal-scroller
      :items="sectionData.children || []"
      content-class="mx-n3"
      stick-to="left"
      class="mb-5 mb-sm-10"
    >
      <template v-slot="{ item }">
        <press-item :item="item.fields" class="mx-3" limited />
      </template>
    </horizontal-scroller>
  </div>
</template>
<script>
import SectionTitle from "@/components/SectionTitle.vue";
import HorizontalScroller from "@/components/HorizontalScroller.vue";
import PressItem from "@/components/PressItem.vue";

export default {
  name: "MainPress",
  components: {
    PressItem,
    HorizontalScroller,
    SectionTitle,
  },
  props: {
    biennale: {
      type: String,
      required: true,
    },
    sectionData: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
